export default "__VITE_ASSET__DX8MZrOK__"